/* Publish by EComposer at 2026-09-29 06:01:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vcd4vdwdphr"]=  window.__ectimmers["ecom-vcd4vdwdphr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vcd4vdwdphr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vcd4vdwdphr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7p9xfxand').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7p9xfxand', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7dyudt07ju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7dyudt07ju', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dyupkwa7fh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dyupkwa7fh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n8yfeeox66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n8yfeeox66', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddn4azq1dfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddn4azq1dfg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-udrm1mhe5qm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udrm1mhe5qm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99w6be4550a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99w6be4550a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ivck4o81qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ivck4o81qb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whwpu941v5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whwpu941v5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvtx6v5bqxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvtx6v5bqxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hage7joczp4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hage7joczp4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9bk0nli3ii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9bk0nli3ii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4shclfvxmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4shclfvxmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tairbll1m6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tairbll1m6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ck7ynapctme').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ck7ynapctme', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ranpvn1mgig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ranpvn1mgig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwon7ic82pc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwon7ic82pc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwnrshztz3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwnrshztz3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yps9q1jfrsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yps9q1jfrsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xeyesqk7zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xeyesqk7zr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7apjltwj3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7apjltwj3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60ikcezmpzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60ikcezmpzq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrqqkzixt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrqqkzixt8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lwumg7idekh"]=  window.__ectimmers["ecom-lwumg7idekh"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-lwumg7idekh"]["xqwd703ja"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-lwumg7idekh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwumg7idekh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qxp9jj37ou').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qxp9jj37ou', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jc57m7fhblj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jc57m7fhblj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9al7d232z6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9al7d232z6u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4w0ihr2z08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4w0ihr2z08', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}